import inicialState from './conclusao.state';
import * as actions from './conclusao.action';

const conclusaoReducer = (state = inicialState, action) => {
  switch (action.type) {
    case actions.CONCLUSAO_FINALIZADA:
      return {
        ...state,
        conclusaoFinalizada: action.payload.conclusaoFinalizada,
      };
    default:
      return state;
  }
};

export default conclusaoReducer;



// WEBPACK FOOTER //
// ./src/pages/laudo/etapas/conclusao/conclusao.reducer.js